export default __webpack_public_path__ + "807b16ffbdb806e98796d78df0683373.png";